import { Arc } from '../../assets/svg/Arc'
import { OfferDiscount } from '../../assets/svg/OfferDiscount'
// import { MobileCheckout } from '../../assets/svg/ArrMobileCheckoutow'
import { Arrow } from '../../assets/svg/Arrow'
import { CircleSvg } from '../../assets/svg/Circle'
import { GameControl } from '../../assets/svg/GameControl'
import { Link } from '../../assets/svg/Link'
import { Omni } from '../../assets/svg/Omni'
import { Privacy } from '../../assets/svg/Privacy'
import { RoundLoadingTimer } from '../../assets/svg/RoundLoadingTimer'
import { SaleIncrease } from '../../assets/svg/SaleIncrease'
import CircleArrow from '../../assets/svg/CircleArrow'
import WelcomeAllBizz from '../../assets/svg/WelcomeAllBizz'
import WelcomeAllBizzMobile from '../../assets/svg/WelcomeAllBizzMobile'

interface SvgProps {
  imageName: string
  height?: number
  width?: number
  color?: any
  outerCircleDirection?: 'left' | 'right'
}

export const SvgImage = ({ imageName, height, outerCircleDirection = 'left', width }: SvgProps) => {
  const SvgList: any = {
    Arrow: <Arrow />,
    Circle: <CircleSvg height={height} outerCircleDirection={outerCircleDirection} />,
    Link: <Link />,
    // MobileCheckout: <MobileCheckout />,
    Offer_Discount: <OfferDiscount />,
    RoundLoadingTimer: <RoundLoadingTimer />,
    Omni: <Omni />,
    Privacy: <Privacy />,
    SaleIncrease: <SaleIncrease />,
    GameControl: <GameControl />,
    Arc: <Arc />,
    CircleArrow: <CircleArrow width={width} height={height} />,
    WelcomeAllBizz: <WelcomeAllBizz width={width} height={height} />,
    WelcomeAllBizzMobile: <WelcomeAllBizzMobile width={width} height={height} />
  }

  const retData = SvgList[imageName]
  return retData ? retData : <Arrow />
}
